import React, { useState, useEffect, useCallback } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { styled } from "@mui/material/styles";
import CurrencyInput from "react-currency-input-field";
import {
  Button,
  IconButton,
  Box,
  Typography,
  TableContainer,
  Dialog,
  DialogContent,
  CircularProgress,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import MDBox from "components/MDBox";
import {
  Paper,
  Tabs,
  Table,
  TableBody,
  TableCell,
  DialogContentText,
  TableRow,
  DialogTitle,
  DialogActions,
  Grid,
  TextField,
  InputAdornment,
  Tooltip,
} from "@mui/material";
import { CheckCircle, Visibility, CloudUpload, Download } from "@mui/icons-material";
import URLs from "constants/urls";
import Cookie from "js-cookie";
import {
  StyledButton,
  StyledAlert,
  StyledSnackbar,
  inputStyle,
  CustomTableCell,
  StyledTableContainer,
  StyledAgGridContainer,
} from "components/StyledComponents/styledComponents.js";
import {
  dialogStyles,
  typoStyle,
  mdBoxStyle,
  dialogContentStyle,
  containerStyle,
  tableCellStyle,
  tableCellFontStyle,
  subDialogContentStyle,
  dialogContentTextStyle,
  approvalStyles,
} from "components/Styles/approvalStyles";
import ResponsiveTabs from "components/StyledComponents/styledComponents";
import { globalStyles } from "components/Styles/globalStyles";
import { StyledTypographyA } from "components/StyledComponents/styledComponents";
import { useMaterialUIController } from "context";

export default function CombinedApprovalForm() {
  const [controller] = useMaterialUIController(); // Get context state
  const { user } = controller; // Destructure user
  const [rowData, setRowData] = useState([]);
  const [disbursedData, setDisbursedData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [activeTab, setActiveTab] = useState(0);
  const [alertType, setAlertType] = useState("success");
  const companyConfig = { companyTDSPercent: 2 };
  const [openPopup, setOpenPopup] = useState(false);
  const jwt_token = Cookie.get("jwt_token");
  const [openDialog, setOpenDialog] = useState(false);
  const MInput = inputStyle();
  const [file, setFile] = useState(null);
  const [paramsData, setParamsData] = useState({});
  const [openFileFolder, setOpenFileFolder] = useState(false);
  const [selectedData, setSelectedData] = React.useState({
    disbursedAmount: "",
  });
  const [payouts, setPayouts] = useState({
    providerPayoutAmount: 0,
    tdsOnProviderPayout: 0,
    finalProviderPayoutAmount: 0,
    dsaPayoutAmountD: 0,
    tdsOnDsaPayout: 0,
    finalDsaPayoutAmount: 0,
    connectorPayout: 0,
    tdsOnConnectorPayout: 0,
    finalConnectorPayoutAmount: 0,
  });
  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  function formatTimestampToDate(timestamp) {
    const date = new Date(timestamp); // Convert timestamp to Date object
    return date.toISOString().slice(0, 10); // Format it as "YYYY-MM-DD"
  }
  const handleOpenDialogFileUploader = (params) => {
    setParamsData(params.data);
    setOpenFileFolder(true);
  };
  const handleCloseDialogFileUploader = () => {
    setOpenFileFolder(false);
    setFile(null);
  };
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const setAlert = (msg, type) => {
    setMessage(msg);
    setAlertType(type);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (activeTab === 0) {
      const misStatus = "C";
      fetchMisData(misStatus);
    } else if (activeTab === 1) {
      fetchDisbursedData();
    }
  }, [activeTab]);

  const fetchMisData = async () => {
    const url = `${URLs.disbursalEntriesUrl}?dsaId=${user.companyId}`;
    setLoading(true);
    try {
      const options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      };
      const response = await fetch(url, options);
      if (response.ok) {
        const data = await response.json();
        setRowData(data);
      } else {
        setAlert("Failed to fetch MIS data", "error");
      }
    } catch (error) {
      setAlert("An error occurred while fetching data", "error");
    } finally {
      setLoading(false);
    }
  };
  const fetchDisbursedData = async () => {
    const url = `${URLs.invoiceEligibleEntriesByDsaId}?dsaId=${user.companyId}`;
    setLoading(true);
    try {
      const options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      };
      const response = await fetch(url, options);
      if (response.ok) {
        const data = await response.json();
        setDisbursedData(data);
      } else {
        setAlert("Failed to fetch MIS data", "error");
      }
    } catch (error) {
      setAlert("An error occurred while fetching data", "error");
    } finally {
      setLoading(false);
    }
  };

  const addToDisbursements = async (payload) => {
    const url = `${URLs.disbursalEntriesPostUrl}`;
    setLoading(true);
    try {
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
        body: JSON.stringify(payload),
      };
      const response = await fetch(url, options);
      if (response.ok) {
        setAlert("The funds have been successfully disbursed.", "success");

        fetchMisData();
      } else {
        setAlert("Failed to disburse", "error");
      }
    } catch (error) {
      setAlert("An error occurred", "error");
    } finally {
      setLoading(false);
    }
  };

  const calculatePayoutAmounts = (
    disbursedAmount = 0,
    grossPayout = 0,
    dsapayout = 0,
    subdsaPayout = 0
  ) => {
    const roundToTwoDecimals = (value) => Math.round(value * 100) / 100;
    const providerPayoutAmount = roundToTwoDecimals((disbursedAmount * grossPayout) / 100);
    const tdsOnProviderPayout = roundToTwoDecimals(
      (providerPayoutAmount * companyConfig.companyTDSPercent) / 100
    );
    const finalProviderPayoutAmount = roundToTwoDecimals(
      providerPayoutAmount - tdsOnProviderPayout
    );

    const dsaPayoutAmountD = roundToTwoDecimals((disbursedAmount * dsapayout) / 100);
    const tdsOnDsaPayout = roundToTwoDecimals(
      (dsaPayoutAmountD * companyConfig.companyTDSPercent) / 100
    );
    const finalDsaPayoutAmount = roundToTwoDecimals(dsaPayoutAmountD - tdsOnDsaPayout);

    const connectorPayout = roundToTwoDecimals((disbursedAmount * subdsaPayout) / 100);
    const tdsOnConnectorPayout = roundToTwoDecimals(
      (connectorPayout * companyConfig.companyTDSPercent) / 100
    );
    const finalConnectorPayoutAmount = roundToTwoDecimals(connectorPayout - tdsOnConnectorPayout);
    return {
      providerPayoutAmount,
      tdsOnProviderPayout,
      finalProviderPayoutAmount,
      dsaPayoutAmountD,
      tdsOnDsaPayout,
      finalDsaPayoutAmount,
      connectorPayout,
      tdsOnConnectorPayout,
      finalConnectorPayoutAmount,
    };
  };

  const handleApprove = (params) => {
    const updatedRowData = params.data;
    const {
      applicationNumber,
      appliedAmount,
      businessTypeCode,
      customerName,
      disbursedAmount,
      dsaCode,
      dsaName,
      dsaPayoutAmount,
      dsaPayoutPercent,
      employeeName,
      entryId,
      finainacialInstitutionName,
      grossPayoutAmount,
      grossPayoutPercent,
      subDsaName,
      subDsaPaymentAmount,
      subDsaPayoutPercent,
      dsaMargin,
      date,
    } = updatedRowData;
    const data = calculatePayoutAmounts(
      disbursedAmount,
      grossPayoutPercent,
      dsaPayoutPercent,
      subDsaPayoutPercent
    );
    if (!disbursedAmount || disbursedAmount == 0) {
      setAlert("Please enter the amount", "error");
      return;
    }
    const payload = {
      disburseId: 0,
      entryId: entryId,
      disbursedAmount: parseFloat(disbursedAmount) || 0,
      grossPayoutPercent: parseFloat(grossPayoutPercent) || 0,
      grossPayoutAmount: parseFloat(data.providerPayoutAmount) || 0,
      finalGrossPayoutAmount: parseFloat(data.finalProviderPayoutAmount) || 0,
      dsapayoutPercent: parseFloat(dsaPayoutPercent) || 0,
      dsapayoutAmount: parseFloat(data.dsaPayoutAmountD) || 0,
      finalDSAGrossPayoutAmount: parseFloat(data.finalDsaPayoutAmount) || 0,
      subDSAPayoutPercent: 0,
      subDSAPaymentAmount: parseFloat(data.connectorPayout) || 0,
      finalSubDSAGrossPayoutAmount: parseFloat(data.finalConnectorPayoutAmount) || 0,
      remarks: "N/A",
      disbursementStatus: "F".charAt(0),
      invoiceStatus: 0,
      invoiceNo: 0,
      dsatdsPercent: 2.0, // Ensuring float
      dsamargin: parseFloat(margin) || 0,
      subDSATdsPercent: 2.0, // Ensuring float
    };

    addToDisbursements(payload);
  };

  useEffect(() => {
    if (selectedData) {
      const {
        providerPayoutAmount,
        tdsOnProviderPayout,
        finalProviderPayoutAmount,
        dsaPayoutAmountD,
        tdsOnDsaPayout,
        finalDsaPayoutAmount,
        connectorPayout,
        tdsOnConnectorPayout,
        finalConnectorPayoutAmount,
      } = calculatePayoutAmounts(
        selectedData.disbursedAmount,
        selectedData.grossPayoutPercent,
        selectedData.dsaPayoutPercent,
        0
      );
      setPayouts({
        providerPayoutAmount,
        tdsOnProviderPayout,
        finalProviderPayoutAmount,
        dsaPayoutAmountD,
        tdsOnDsaPayout,
        finalDsaPayoutAmount,
        connectorPayout,
        tdsOnConnectorPayout,
        finalConnectorPayoutAmount,
      });
    }
  }, [selectedData]);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return `${date.getDate()}-${date.toLocaleString("en-US", {
      month: "short",
    })}-${date.getFullYear()}`;
  };
  const columnDefs = [
    {
      field: "date",
      headerName: "Date",
      sortable: true,
      filter: true,
      width: 120,
      valueFormatter: (params) => formatDate(params.value),
      sort: "desc",
    },
    {
      field: "applicationNumber",
      headerName: "App. No.",
      filter: true,
      sortable: true,
      minWidth: 130,
      flex: 1,
    },
    {
      field: "customerName",
      headerName: "Customer Name",
      filter: true,
      sortable: true,
      minWidth: 150,
      flex: 1.5,
    },
    {
      field: "businessTypeCode",
      headerName: "Product Type",
      filter: true,
      sortable: true,
    },
    {
      field: "appliedAmount",
      headerName: "Loan Amount",
      filter: true,
      sortable: true,
      width: 170,
      cellStyle: { textAlign: "right" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
    },
    {
      field: "finainacialInstitutionName",
      headerName: "Banker Name",
      filter: true,
      sortable: true,
      flex: 1.5,
    },
    {
      field: "dsaName",
      headerName: "DSA Name",
      filter: true,
      sortable: true,
    },

    {
      headerName: "Disbursed Amount",
      field: "disbursedAmount",
      cellStyle: { padding: 0 },
      cellRenderer: (params) => {
        const [inputValue, setInputValue] = useState(params.value ? String(params.value) : "");

        useEffect(() => {
          if (params.value !== inputValue) {
            setInputValue(params.value ? String(params.value) : "");
          }
        }, [params.value]);

        const handleBlur = () => {
          const numericValue = parseFloat(inputValue.replace(/[^0-9.]/g, ""));
          if (!isNaN(numericValue)) {
            params.data.disbursedAmount = numericValue;
            params.api.refreshCells({ rowNodes: [params.node] });
          } else {
            params.data.disbursedAmount = 0;
            params.api.refreshCells({ rowNodes: [params.node] });
          }
        };

        // Update local state when user types
        const handleValueChange = (value) => {
          setInputValue(value || "");
        };

        return (
          <TextField
            variant="outlined"
            fullWidth
            value={inputValue}
            onBlur={handleBlur}
            InputProps={{
              inputComponent: CurrencyInput,
              inputProps: {
                decimalsLimit: 2,
                prefix: "₹ ",
                decimalSeparator: ".",
                groupSeparator: ",",
                value: inputValue,
                onValueChange: handleValueChange,
                intlConfig: { locale: "en-IN" },
                allowNegative: false,
              },
            }}
            sx={{
              height: "100%",
              "& .MuiInputBase-root": {
                height: "100%",
              },
            }}
          />
        );
      },
      flex: 1,
    },
    {
      field: "grossPayoutPercent",
      headerName: "Revenue (%)",
      filter: true,
      sortable: true,
      maxWidth: 120,
      cellStyle: { textAlign: "right", fontWeight: "500" },
    },
    {
      field: "dsaPayoutPercent",
      headerName: "DSA (%)",
      filter: true,
      sortable: true,
      maxWidth: 100,
      cellStyle: { textAlign: "right", fontWeight: "500" },
    },
    {
      field: "subDsaPayoutPercent",
      headerName: "Sub DSA Pay-out (%)",
      sortable: true,
      filter: true,
      flex: 1.5,
      editable: true,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) => (params.value ? `${params.value.toFixed(2)}%` : ""),
    },
    {
      headerName: "Actions",
      cellRenderer: (params) => (
        <>
          <Tooltip title="View" arrow>
            <IconButton type="button" onClick={() => handleViewClick(params)} color="primary">
              <Visibility />
            </IconButton>
          </Tooltip>
          <Tooltip title="Upload" arrow>
            <IconButton
              type="button"
              onClick={() => handleOpenDialogFileUploader(params)}
              color="primary"
            >
              <CloudUpload />
            </IconButton>
          </Tooltip>
          <Tooltip title="download" arrow>
            <IconButton type="button" onClick={() => triggerS3File(params)} color="primary">
              <DownloadIcon />
            </IconButton>
          </Tooltip>
        </>
      ),
      minWidth: 130,
      flex: 1,
    },
  ];
  const columns = [
    // Date
    {
      field: "date",
      headerName: "Date",
      sortable: true,
      filter: true,
      width: 130,
      valueFormatter: (params) => formatDate(params.value),
      sort: "desc",
    },
    // Application No.
    {
      headerName: "Appl. No.",
      field: "applicationNumber",
      filter: true,
      sorted: true,
      minWidth: 70,
      flex: 1,
    },
    // Customer
    { field: "customerName", headerName: "Customer Name", sortable: true, filter: true, flex: 1.5 },

    // Disbursed Amount (editable)
    {
      field: "disbursedAmount",
      headerName: "Disbursed Amount",
      sortable: true,
      filter: true,
      flex: 1.5,
      editable: true,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 }) || "0.00"}`,
    },

    // Product Type
    {
      field: "businessTypeCode",
      headerName: "Product Type",
      sortable: true,
      filter: true,
      flex: 1,
    },

    // Provider
    {
      field: "financialInstitutionName",
      headerName: "Provider Name",
      sortable: true,
      filter: true,
    },

    // Gross Payout Percent (editable)
    {
      field: "grossPayoutPercent",
      headerName: "Revenue (%)",
      sortable: true,
      filter: true,
      flex: 1.5,
      editable: true,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) => (params.value ? `${params.value.toFixed(2)}%` : ""),
    },

    // Gross Payout Amount (calculated)
    {
      field: "grossPayoutAmount",
      headerName: "Revenue",
      sortable: true,
      filter: true,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 }) || "0.00"}`,
    },

    // DSA Payout Percent (editable)
    {
      field: "dsaPayoutPercent",
      headerName: "DSA Pay-out (%)",
      sortable: true,
      filter: true,
      flex: 1.5,
      editable: true,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) => (params.value ? `${params.value.toFixed(2)}%` : ""),
    },

    // DSA Payout Amount (calculated)
    {
      field: "dsaPayoutAmount",
      headerName: "DSA Payout",
      sortable: true,
      filter: true,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 }) || "0.00"}`,
    },
    // Save Button Column
    {
      headerName: "Actions",
      field: "actions",
      cellRenderer: (params) => (
        <StyledButton sx={{ height: "30px" }} onClick={() => handleSaveRow(params.data)}>
          Save
        </StyledButton>
      ),
    },
  ];
  const handleViewClick = (params) => {
    const margin = Math.round(
      (params.data.dsaPayoutPercent / params.data.grossPayoutPercent) * 100,
      2
    );
    setSelectedData({ disbursedAmount: 0, ...params.data, dsaMargin: margin });
    setOpenPopup(true);
  };
  const handleCloseDailog = () => {
    setOpenPopup(false);
  };
  const handleOpenDialog = () => {
    if (selectedData && selectedData.disbursedAmount == 0) {
      setAlert("Enter Disbursed amount", "error"); // Show alert with an error message
      return; // Exit the function to prevent the API call
    }
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const handleConfirmClick = async () => {
    const payload = {
      disburseId: 0,
      entryId: selectedData.entryId,
      netDisburseAmount: selectedData.disbursedAmount,
      disbursedAmount: selectedData.disbursedAmount,
      grossPayoutPercent: selectedData.grossPayoutPercent,
      grossPayoutAmount: payouts.providerPayoutAmount,
      finalGrossPayoutAmount: payouts.finalProviderPayoutAmount,
      dsapayoutPercent: selectedData.dsaPayoutPercent,
      dsapayoutAmount: payouts.dsaPayoutAmountD,
      finalDSAGrossPayoutAmount: payouts.finalDsaPayoutAmount,
      subDSAPayoutPercent: selectedData.subDsaPayoutPercent,
      subDSAPaymentAmount: payouts.connectorPayout,
      finalSubDSAGrossPayoutAmount: payouts.finalConnectorPayoutAmount,
      remarks: "N/A",
      disbursementStatus: "F".charAt(0),
      invoiceStatus: 0,
      invoiceNo: 0,
      dsatdsPercent: 2,
      dsamargin: selectedData.dsaMargin,
      subDSATdsPercent: 2,
    };
    setOpenDialog(false);
    setOpenPopup(false);
    addToDisbursements(payload);
  };
  const onCellValueChanged = (params) => {
    const { data, colDef } = params;

    if (
      colDef.field === "disbursedAmount" ||
      colDef.field === "grossPayoutPercent" ||
      colDef.field === "dsaPayoutPercent" ||
      colDef.field === "subDsaPayoutPercent"
    ) {
      data.grossPayoutAmount = data.disbursedAmount * (data.grossPayoutPercent / 100);
      data.dsaPayoutAmount = data.disbursedAmount * (data.dsaPayoutPercent / 100);
      data.subDsaPaymentAmount = data.disbursedAmount * (data.subDsaPayoutPercent / 100);
      params.api.applyTransaction({ update: [data] });
    }
  };
  const handleSaveRow = async (rowData) => {
    const payload = {
      disburseId: rowData.disburseId,
      entryId: rowData.entryId,
      netDisburseAmount: parseFloat(rowData.netDisburseAmount) || 0,
      disbursedAmount: parseFloat(rowData.disbursedAmount) || 0,
      grossPayoutPercent: parseFloat(rowData.grossPayoutPercent) || 0,
      grossPayoutAmount: parseFloat(rowData.grossPayoutAmount) || 0,
      finalGrossPayoutAmount: parseFloat(rowData.grossPayoutAmount) || 0,
      finalDSAGrossPayoutAmount: parseFloat(rowData.dsaPayoutAmount) || 0,
      finalSubDSAGrossPayoutAmount: 0,
      remarks: rowData.remarks || "",
      disbursementStatus: rowData.disbursementStatus || "",
      invoiceStatus: rowData.invoiceStatus || 0,
      subDSATdsPercent: parseFloat(rowData.subDSATdsPercent) || 0,
      dsamargin: parseFloat(rowData.dsamargin) || 0,
      dsapayoutAmount: parseFloat(rowData.dsaPayoutAmount) || 0,
      dsatdsPercent: parseFloat(rowData.dsatdsPercent) || 0,
      dsapayoutPercent: parseFloat(rowData.dsaPayoutPercent) || 0,
      subDSAPayoutPercent: 0,
      subDSAPaymentAmount: parseFloat(rowData.subDsaPaymentAmount) || 0,
    };
    try {
      const response = await fetch(`${URLs.updateDisbursement}/${rowData.disburseId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        setAlert("Row updated successfully!", "success");
        fetchDisbursedData(); // Refresh grid
      } else {
        setAlert("Failed to update row", "error");
      }
    } catch (error) {
      setAlert("An error occurred during update", "error");
    }
  };
  const triggerS3File = async (params) => {
    setParamsData();
    const url = getPresignedUrl({
      fileName: params.data.applicationNumber,
      group: "disbursement",
      env: "production",
      type: "download",
    });
    try {
      const downloadResponse = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      });
      if (downloadResponse.ok) {
        const presignedUrl = await downloadResponse.text();

        if (!presignedUrl.startsWith("http")) {
          throw new Error("Invalid Pre-Signed URL received");
        }
        if (presignedUrl) {
          window.open(presignedUrl, "_blank");
          return;
        }
      }
    } catch {
      setAlert("Failed to Download", "error");
    }
  };
  const uploadFileToS3 = async () => {
    if (!file) {
      setAlert("Please select a file first.", "error");
      return;
    }
    const uploadUrl = getPresignedUrl({
      fileName: paramsData.applicationNumber,
      group: "disbursement",
      env: "production",
      type: "upload",
    });
    try {
      const response = await fetch(uploadUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${jwt_token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to get pre-signed URL");

      const presignedUrl = await response.text();

      if (!presignedUrl.startsWith("http")) {
        throw new Error("Invalid Pre-Signed URL received");
      }
      const uploadResponse = await fetch(presignedUrl, {
        method: "PUT",
        body: file,
        headers: {
          "Content-Type": "message/rfc822",
        },
      });

      if (uploadResponse.ok) {
        setAlert("File uploaded successfully!", "success");
        setOpenFileFolder(false);
      } else {
        const errorText = await uploadResponse.text();
        throw new Error(`Upload failed: ${uploadResponse.statusText}, Details: ${errorText}`);
      }
    } catch (error) {
      console.error("Upload Error:", error);
      setAlert("File upload failed.", "error");
    }
  };
  const tabs = [{ label: "Ready to Disburse" }, { label: "Already Disbursed" }];
  return (
    <DashboardLayout>
      <StyledTableContainer>
        <StyledSnackbar
          open={open}
          autoHideDuration={5000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          severity={alertType}
        >
          <StyledAlert onClose={handleClose} severity={alertType}>
            {message}
          </StyledAlert>
        </StyledSnackbar>
        <Dialog open={openFileFolder} onClose={handleCloseDialogFileUploader}>
          <StyledTypographyA mt={2}>Upload File</StyledTypographyA>
          <DialogContent>
            <TextField
              sx={MInput.b}
              InputLabelProps={{
                sx: {
                  color: MInput.a,
                },
              }}
              type="file"
              onChange={handleFileChange}
            />
          </DialogContent>
          <DialogActions>
            <StyledButton onClick={handleCloseDialogFileUploader} color="secondary">
              Cancel
            </StyledButton>
            <StyledButton onClick={uploadFileToS3} color="primary" variant="contained">
              Submit
            </StyledButton>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openPopup}
          onClose={handleCloseDailog}
          PaperProps={{
            ...dialogStyles,
          }}
          fullScreen
          sx={{
            ".MuiDialog-paper": {
              width: "70%",
              height: "90%",
              maxHeight: "700px",
              maxWidth: "none", // Remove the default max-width limit
              margin: "auto", // Center the dialog
              minWidth: "300px",
              borderRadius: "7px",
            },
          }}
        >
          <DialogTitle sx={{ position: "relative", padding: "0px", zIndex: "1000" }}>
            <MDBox
              variant="gradient"
              borderRadius="lg"
              coloredShadow="info"
              textAlign="center"
              sx={{ ...mdBoxStyle, backgroundColor: MInput.a }}
            >
              <Typography variant="h6" fontWeight="medium" color="#FFFFFF" {...typoStyle}>
                Loan Entry Details
              </Typography>
            </MDBox>
          </DialogTitle>
          <DialogContent {...dialogContentStyle}>
            <Grid container spacing={2} pt={1}>
              <Grid item xs={12} sm={12} md={2}>
                <TextField
                  label="Date"
                  fullWidth
                  value={
                    selectedData?.date
                      ? formatTimestampToDate(selectedData.date)
                      : new Date().toLocaleDateString()
                  }
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={MInput.b}
                  InputLabelProps={{
                    sx: {
                      color: MInput.a,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  label="Application Number"
                  fullWidth
                  value={selectedData.applicationNumber}
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={MInput.b}
                  InputLabelProps={{
                    sx: {
                      color: MInput.a,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  label="DSA Name"
                  fullWidth
                  value={selectedData.dsaName || "Unknown DSA"}
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={MInput.b}
                  InputLabelProps={{
                    sx: {
                      color: MInput.a,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  label="Sub DSA"
                  fullWidth
                  value={selectedData.subDsaName || "N/A"}
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={MInput.b}
                  InputLabelProps={{
                    sx: {
                      color: MInput.a,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  label="Andromeda Manager"
                  fullWidth
                  value={selectedData.employeeName || "Unknown Manager"}
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={MInput.b}
                  InputLabelProps={{
                    sx: {
                      color: MInput.a,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  label="Product Type"
                  fullWidth
                  value={selectedData.businessTypeCode || "Unknown Product"}
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={MInput.b}
                  InputLabelProps={{
                    sx: {
                      color: MInput.a,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={2.4}>
                <TextField
                  label="Customer Name"
                  fullWidth
                  value={selectedData.customerName}
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={MInput.b}
                  InputLabelProps={{
                    sx: {
                      color: MInput.a,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={2.4}>
                <TextField
                  label="Banker Name"
                  fullWidth
                  value={selectedData.finainacialInstitutionName || "Unknown Bank"}
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={MInput.b}
                  InputLabelProps={{
                    sx: {
                      color: MInput.a,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={2.4}>
                <TextField
                  label="Loan Amount"
                  fullWidth
                  value={`${selectedData?.appliedAmount?.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                    readOnly: true,
                  }}
                  sx={MInput.b}
                  InputLabelProps={{
                    sx: {
                      color: MInput.a,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6} xl={2.4}>
                <TextField
                  label="Loan Disbursed Amount"
                  fullWidth
                  required
                  value={selectedData.disbursedAmount}
                  onChange={() => {}}
                  InputProps={{
                    inputComponent: CurrencyInput,
                    inputProps: {
                      value: selectedData.disbursedAmount,
                      decimalsLimit: 2,
                      prefix: "₹ ",
                      onValueChange: (value) => {
                        if (selectedData.appliedAmount < selectedData.disbursedAmount) {
                          setAlert("Disbursed Amount greater than appplied amount", "error");
                        }
                        setSelectedData({ ...selectedData, disbursedAmount: value });
                      },
                      intlConfig: { locale: "en-IN" },
                    },
                  }}
                  sx={MInput.b}
                  InputLabelProps={{
                    sx: {
                      color: MInput.a,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={2.4}>
                <TextField
                  label="Remarks"
                  multiline
                  rows={1}
                  fullWidth
                  value={selectedData.remarks}
                  sx={MInput.b}
                  InputLabelProps={{
                    sx: {
                      color: MInput.a,
                    },
                  }}
                />
              </Grid>
            </Grid>
            <TableContainer component={Paper} {...containerStyle}>
              <Table>
                <TableBody>
                  <TableRow
                    sx={{
                      height: "30px", // Set a smaller height
                      "& .MuiTableCell-root": {
                        padding: "4px 10px", // Reduce padding for cells within the row
                      },
                    }}
                  >
                    <CustomTableCell minWidth="100px" flexGrow={1} fontWeight="normal">
                      Banker Payout @ {Number(selectedData.grossPayoutPercent).toFixed(2)} %
                    </CustomTableCell>
                    <CustomTableCell
                      minWidth="100px"
                      flexGrow={1}
                      fontWeight="normal"
                      align="right"
                    >
                      ₹
                      {` ${(Number(payouts.providerPayoutAmount) || 0).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}`}
                    </CustomTableCell>
                    <CustomTableCell
                      minWidth="100px"
                      flexGrow={1}
                      fontWeight="normal"
                    ></CustomTableCell>
                  </TableRow>
                  <TableRow
                    sx={{
                      height: "30px", // Set a smaller height
                      "& .MuiTableCell-root": {
                        padding: "4px 10px", // Reduce padding for cells within the row
                      },
                    }}
                  >
                    <CustomTableCell minWidth="100px" flexGrow={1} fontWeight="normal">
                      Less : TDS @ {companyConfig.companyTDSPercent} %
                    </CustomTableCell>
                    <CustomTableCell
                      minWidth="100px"
                      flexGrow={1}
                      fontWeight="normal"
                      align="right"
                    >
                      ₹
                      {`${(Number(payouts.tdsOnProviderPayout) || 0).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}`}
                    </CustomTableCell>
                    <CustomTableCell
                      minWidth="100px"
                      flexGrow={1}
                      fontWeight="normal"
                    ></CustomTableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: "#566573" }}>
                    <CustomTableCell
                      sx={{ color: "#ffffff" }}
                      minWidth="100px"
                      colSpan={2}
                      flexGrow={1}
                      fontWeight="bold"
                    >
                      Net Banker Payout
                    </CustomTableCell>
                    <CustomTableCell
                      sx={{ color: "#ffffff" }}
                      minWidth="100px"
                      flexGrow={1}
                      fontWeight="bold"
                      align="right"
                    >
                      ₹
                      {` ${(Number(payouts.finalProviderPayoutAmount) || 0).toLocaleString(
                        "en-IN",
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }
                      )}`}
                    </CustomTableCell>
                  </TableRow>
                  <TableRow
                    sx={{
                      height: "30px", // Set a smaller height
                      "& .MuiTableCell-root": {
                        padding: "4px 10px", // Reduce padding for cells within the row
                      },
                    }}
                  >
                    <CustomTableCell minWidth="100px" flexGrow={1} fontWeight="normal">
                      DSA Payout @ {Number(selectedData.dsaPayoutPercent).toFixed(2)} %
                    </CustomTableCell>
                    <CustomTableCell
                      minWidth="100px"
                      flexGrow={1}
                      fontWeight="normal"
                      align="right"
                    >
                      ₹
                      {` ${(Number(payouts.dsaPayoutAmountD) || 0).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}`}
                    </CustomTableCell>
                    <CustomTableCell
                      minWidth="100px"
                      flexGrow={1}
                      fontWeight="normal"
                    ></CustomTableCell>
                  </TableRow>
                  <TableRow
                    sx={{
                      height: "30px", // Set a smaller height
                      "& .MuiTableCell-root": {
                        padding: "4px 10px", // Reduce padding for cells within the row
                      },
                    }}
                  >
                    <CustomTableCell minWidth="100px" flexGrow={1} fontWeight="normal">
                      Less : TDS @ {companyConfig.companyTDSPercent} %
                    </CustomTableCell>
                    <CustomTableCell
                      minWidth="100px"
                      flexGrow={1}
                      fontWeight="normal"
                      align="right"
                    >
                      ₹
                      {` ${(Number(payouts.tdsOnDsaPayout) || 0).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}`}
                    </CustomTableCell>
                    <CustomTableCell
                      minWidth="100px"
                      flexGrow={1}
                      fontWeight="normal"
                    ></CustomTableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: "#566573" }}>
                    <CustomTableCell
                      sx={{ color: "#ffffff" }}
                      minWidth="100px"
                      colSpan={2}
                      flexGrow={1}
                      fontWeight="bold"
                    >
                      Net DSA Payout
                    </CustomTableCell>
                    <CustomTableCell
                      sx={{ color: "#ffffff" }}
                      minWidth="100px"
                      flexGrow={1}
                      fontWeight="bold"
                      align="right"
                    >
                      ₹
                      {` ${(Number(payouts.finalDsaPayoutAmount) || 0).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}`}
                    </CustomTableCell>
                  </TableRow>
                  <TableRow></TableRow>
                  <TableRow
                    sx={{
                      height: "30px", // Set a smaller height
                      "& .MuiTableCell-root": {
                        padding: "4px 10px", // Reduce padding for cells within the row
                      },
                    }}
                  >
                    <CustomTableCell minWidth="100px" flexGrow={1} fontWeight="normal">
                      Connector Payout @ {Number(selectedData.subDsaPayoutPercent).toFixed(2)} %
                    </CustomTableCell>
                    <CustomTableCell
                      minWidth="100px"
                      flexGrow={1}
                      fontWeight="normal"
                      align="right"
                    >
                      ₹
                      {` ${(Number(payouts.connectorPayout) || 0).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}`}
                    </CustomTableCell>
                    <CustomTableCell
                      minWidth="100px"
                      flexGrow={1}
                      fontWeight="normal"
                    ></CustomTableCell>
                  </TableRow>
                  <TableRow
                    sx={{
                      height: "30px", // Set a smaller height
                      "& .MuiTableCell-root": {
                        padding: "4px 10px", // Reduce padding for cells within the row
                      },
                    }}
                  >
                    <CustomTableCell minWidth="100px" flexGrow={1} fontWeight="normal">
                      Less : TDS @ {companyConfig.companyTDSPercent} %
                    </CustomTableCell>
                    <CustomTableCell
                      minWidth="100px"
                      flexGrow={1}
                      fontWeight="normal"
                      align="right"
                    >
                      ₹
                      {` ${(Number(payouts.tdsOnConnectorPayout) || 0).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}`}
                    </CustomTableCell>
                    <CustomTableCell
                      minWidth="100px"
                      flexGrow={1}
                      fontWeight="normal"
                    ></CustomTableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: "#566573" }}>
                    <CustomTableCell
                      sx={{ color: "#ffffff" }}
                      minWidth="100px"
                      colSpan={2}
                      flexGrow={1}
                      fontWeight="bold"
                    >
                      Net Connector Payout
                    </CustomTableCell>
                    <CustomTableCell
                      sx={{ color: "#ffffff" }}
                      minWidth="100px"
                      flexGrow={1}
                      fontWeight="bold"
                      align="right"
                    >
                      ₹
                      {` ${(Number(payouts.finalConnectorPayoutAmount) || 0).toLocaleString(
                        "en-IN",
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }
                      )}`}
                    </CustomTableCell>
                  </TableRow>
                  <TableRow
                    sx={{
                      backgroundColor:
                        Number(payouts.finalDsaPayoutAmount - payouts.finalConnectorPayoutAmount) >=
                        0
                          ? "purple"
                          : "red", // Set purple for profit, red for loss
                    }}
                  >
                    <CustomTableCell
                      sx={{ color: "#ffffff" }}
                      minWidth="100px"
                      colSpan={2}
                      flexGrow={1}
                      fontWeight="bold"
                    >
                      {Number(payouts.finalDsaPayoutAmount - payouts.finalConnectorPayoutAmount) > 0
                        ? "Net DSA Profit / Loss"
                        : "Net DSA Loss"}{" "}
                      {/* Conditionally display 'Profit' or 'Loss' */}
                    </CustomTableCell>
                    <CustomTableCell
                      sx={{ color: "#ffffff" }}
                      minWidth="100px"
                      flexGrow={1}
                      fontWeight="bold"
                      align="right"
                    >
                      ₹
                      {` ${(
                        Number(payouts.finalDsaPayoutAmount - payouts.connectorPayout) || 0
                      ).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}`}
                    </CustomTableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
          <Dialog open={openDialog} onClose={handleCloseDialog}>
            <DialogContent sx={subDialogContentStyle}>
              <DialogContentText sx={dialogContentTextStyle}>
                {`Are you sure you want to close this business with ₹ ${Number(
                  selectedData.disbursedAmount
                ).toLocaleString()} disbursed Amount?`}
              </DialogContentText>
            </DialogContent>
            <DialogActions sx={approvalStyles.dialogActions}>
              <StyledButton onClick={handleConfirmClick}>Yes</StyledButton>
              <StyledButton onClick={handleCloseDialog} variant="outlined">
                No
              </StyledButton>
            </DialogActions>
          </Dialog>
          <DialogActions>
            <StyledButton onClick={handleOpenDialog}>Confirm</StyledButton>
            <StyledButton onClick={handleCloseDailog}>Close</StyledButton>
          </DialogActions>
        </Dialog>
        <ResponsiveTabs
          tabs={tabs}
          activeTab={activeTab}
          onChange={handleChange}
          labelColor="#ffffff"
          bgColor="#e0f7fa"
        />
        {activeTab == 0 && (
          <StyledAgGridContainer
            sx={{ flexGrow: 1, mt: 2 }}
            component={Paper}
            className={`ag-theme-alpine`}
          >
            <AgGridReact
              columnDefs={columnDefs}
              rowData={rowData}
              defaultColDef={{
                editable: false,
                sortable: true,
                filter: true,
                flex: 1,
              }}
              pagination={true}
            />
          </StyledAgGridContainer>
        )}
        {activeTab == 1 && (
          <StyledAgGridContainer
            sx={{ flexGrow: 1, mt: 2 }}
            component={Paper}
            className={`ag-theme-alpine`}
          >
            <AgGridReact
              columnDefs={columns}
              rowData={disbursedData}
              defaultColDef={{
                editable: false,
                sortable: true,
                filter: true,
                flex: 1,
              }}
              pagination={true}
              onCellValueChanged={onCellValueChanged}
            />
          </StyledAgGridContainer>
        )}
      </StyledTableContainer>
    </DashboardLayout>
  );
}
